// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0dbe4508","453":"f55134a4","732":"f8755e88","977":"b4e1c292"}[chunkId] + ".chunk.js";
};